import { render, staticRenderFns } from "./PracticeStats.vue?vue&type=template&id=4da81727&scoped=true&"
import script from "./PracticeStats.vue?vue&type=script&lang=js&"
export * from "./PracticeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da81727",
  null
  
)

export default component.exports